module.exports = __webpack_public_path__ + "static/media/chujihuiyuan.f57ba0bb.png";